import { useState } from "react";

import { styled } from "@/root/stitches.config";
import { Title } from "@/components/title";
import { Button } from "@/components/button";

import Poster from "@/assets/announcement/poster1.webp";


const Container = styled("section", {
    padding: "5rem 5%",
    backgroundColor: "$dark",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    "@mobile": {
        padding: "3rem 5%",
    },
});

const Card = styled("div", {
    width: "100%",
    maxWidth: "900px",
    height: "520px",

    backgroundColor: "#060606",
    borderRadius: "20px",
    overflow: "hidden",

    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    boxShadow: "0 12px 30px rgba(0,0,0,.3)",

    animation: "fade .35s",

    "@keyframes fade": {
        from: {
            opacity: 0,
            transform: "translateY(8px)",
        },
        to: {
            opacity: 1,
            transform: "translateY(0)",
        },
    },

    "@mobile": {
        height: "340px",
    },
});

const ButtonContainer = styled("div", {
    marginTop: "1.5rem",
    display: "flex",
    justifyContent: "center",
    gap: "1rem",

    "@mobile": {
        flexDirection: "column",
        width: "100%",
        maxWidth: "320px",
    },
});

export default function Announcement() {
    const [active, setActive] = useState("poster");

    return (
        <Container>
            <Title
                css={{
                    color: "$white",
                    textAlign: "center",
                }}
            >
                Announcement
            </Title>

            <Card key={active}>
                {active === "poster" ? (
                    <img
                        src={Poster}
                        alt="Announcement Poster"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            display: "block",
                        }}
                    />
                ) : (
                    <video
                        src={Reel}
                        controls
                        playsInline
                        preload="metadata"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            display: "block",
                        }}
                    />
                )}
            </Card>

            <ButtonContainer>
                <Button
                    onClick={() => setActive("poster")}
                    css={{
                        minWidth: "170px",
                        opacity: active === "poster" ? 1 : 0.65,
                    }}
                >
                    📷 Poster
                </Button>

                <Button
                    onClick={() => setActive("video")}
                    css={{
                        minWidth: "170px",
                        opacity: active === "video" ? 1 : 0.65,
                    }}
                >
                    🎥 Reel
                </Button>
            </ButtonContainer>
        </Container>
    );
}